// extracted by mini-css-extract-plugin
module.exports = {"container":"Food_container__1Xp3f","foodForm":"Food_foodForm__1SSac","foodList":"Food_foodList__1UKq4","foodItem":"Food_foodItem__3JhgP","addButton":"Food_addButton__343ts"};